export const UPLOAD_REQUEST = 'UPLOAD_REQUEST';
export const UPLOAD_FAILURE = 'UPLOAD_FAILURE';
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS';
